import { NICmsContentComponent } from '@icms/core/content';
import { NCustomerGroups } from '../../customer/groups/customer-groups';

export namespace NOffCanvas {
    export const ID = 'off-canvas-menu';

    export enum EOpenState {
        closed,
        opened
    }

    export interface IContent extends NICmsContentComponent.IData, IMenuQuickLink, IMenuNewEditSection, IMenuBannerSection {
        menu: IMenuFirstLevelItem[];
        footerItemsShow: boolean;
        footerItems: IFooterItems[];
        footerItemsShowBVariant: boolean;
        footerItemsBVariant: IFooterVariantBItems[];
    }

    export interface IBaseItem {
        text: string;
        text_color: string;
        isTextBold: boolean;
        copy_text?: string;
        copy_text_color: string;
        link: string;
        is_separator: boolean;
        display_arrow: boolean;
        hideNotifications: boolean;
        visibility?: NCustomerGroups.TId | NCustomerGroups.TId[];
    }

    export interface IMenuLevelItem extends IBaseItem {
        display_arrow: boolean;
    }

    export interface IMenuFirstLevelItem extends IMenuLevelItem, IMenuQuickLink, IMenuNewEditSection, IMenuBannerSection {
        image: string;
        second_level_turn_on: boolean;
        second_level_background_color: string;
        second_level_items: IMenuSecondLevelItem[];
    }

    export interface IMenuSecondLevelItem extends IMenuLevelItem, IMenuQuickLink, IMenuNewEditSection, IMenuBannerSection {
        third_level_turn_on: boolean;
        third_level_items: IMenuThirdLevelItem[];
    }

    export interface IMenuThirdLevelItem extends IMenuLevelItem {
        fourth_level_turn_on: boolean;
        fourth_level_items: IMenuFourthLevelItem[];
    }

    export interface IMenuFourthLevelItem extends IMenuLevelItem {}

    export interface IMenuItem extends IMenuFirstLevelItem, IMenuSecondLevelItem, IMenuThirdLevelItem, IMenuFourthLevelItem {}

    export interface IMenuQuickLink {
        quick_links_turn_on: boolean;
        quick_links_text: string;
        quick_links_items: IMenuQuickLinkItem[];
        visibility?: NCustomerGroups.TId | NCustomerGroups.TId[];
    }

    export interface IMenuQuickLinkItem extends IBaseItem {
        image: string;
    }

    export interface IMenuNewEditSection {
        newEditsSectionTurnOn: boolean;
        newEditsSectionTitle: string;
        newEditsSectionItems: IMenuNewEditSectionItem[];
    }

    export interface IMenuNewEditSectionItem {
        text: string;
        textColor: string;
        link: string;
    }

    export interface IMenuBannerSection {
        bannersSectionTurnOn: boolean;
        bannerSectionItems: IMenuBannerItem[];
    }

    export interface IMenuBannerItem {
        image: string;
        text: string;
        textColor: string;
        textCTA: string;
        link: string;
    }

    export interface IFooterItems {
        type: 'link' | 'countrySelector';
        ctaText: string;
        ctaLink: string;
        fontColor: string;
    }

    export interface IFooterVariantBItems {
        icon: string;
        ctaText: string;
        ctaLink: string;
        fontColor: string;
    }
}
